module.exports = __webpack_public_path__ + "static/appDemo04-1c411d528c1074e4d26f7f42665133ca.png";